import AboutMe from "../AboutMe";
import Footer from "../Footer";
// import ContactMe from "../ContactMe";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import MySkills from "../MySkills";
import Skilldrop from "../Skilldrop";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutMe />
      <MySkills />
      <Skilldrop />
      <MyPortfolio />
      {/* <ContactMe /> */}
      <Footer />
    </>
  );
}
